import { Flex } from "@chakra-ui/layout";
import { IoIosClose } from "react-icons/io";

interface TagAssuntoProps {
  onRemove?: (assunto: string) => any;

  assunto: string;
}

export default function TagAssunto({ onRemove, assunto }: TagAssuntoProps) {
  return (
    <>
      <Flex
        align="center"
        p="4px"
        rounded="16px"
        border="solid 1px"
        mt="4px"
        px="5px"
      >
        {assunto}

        <Flex
          h="15px"
          align="center"
          justifyContent="center"
          borderLeft="solid 1px"
          fontSize="22px"
          ml="4px"
          cursor="pointer"
          onClick={() => onRemove?.(assunto)}
        >
          <IoIosClose />
        </Flex>
      </Flex>
    </>
  );
}
